import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { RevenueModel } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { SelectBasedField } from '@new/__global/components/Filters/FiltersVariations/Select'

import { FiltersSharedProps } from './Filters.types'

interface RevenueModelSelectFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

const AllValue = 'All'
const allOption = {
  value: AllValue,
  label: 'All',
}

const omitOptions = [RevenueModel.undefined]

const revenueModelDefaultOptions = Object.values(RevenueModel)
  .filter(option => !omitOptions.includes(option))
  .map(option => ({
    label: humanizeString(option),
    value: option,
  }))

const revenueModelOptions = [allOption, ...revenueModelDefaultOptions]

export const RevenueModelSelectFilter: FC<RevenueModelSelectFilterProps> = ({
  label,
  initialValue,
  isSidebarFilter,
  onChange,
}) => {
  const handleChange = (option?: string) => {
    onChange(option === AllValue ? undefined : (option as string))
  }

  const currentValue = revenueModelOptions.find(option => option.value === initialValue)?.value

  return (
    <SelectBasedField
      groupId="rev-model-filter"
      title={label || 'Rev. Model'}
      inputTitle={label}
      options={revenueModelOptions}
      initialValue={currentValue || AllValue}
      onChange={handleChange}
      isSidebarFilter={isSidebarFilter}
      inputWidth={130}
    />
  )
}
